import { render, staticRenderFns } from "./ShopBundleProductAgreementList.vue?vue&type=template&id=3f144a94&"
import script from "./ShopBundleProductAgreementList.vue?vue&type=script&lang=js&"
export * from "./ShopBundleProductAgreementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports